import { type ReportKind } from "@digits-graphql/frontend/graphql-bearer"

export const CUSTOM_STATEMENT_KIND = "Custom"

export type FinancialsStatementKind = ReportKind | typeof CUSTOM_STATEMENT_KIND
